import { getRedirectUrl } from "~/utils";

export default function ({ redirect, route }) {
  if (route?.path?.includes("/login")) {
    return redirect("/sign-in");
  }
}
